export { default as Header } from "./header/header";
export { default as SEO } from "./seo/seo";
export {default as Footer} from "./footer/footer"
